import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, API } from "@/api";
import Shell from "@/components/Shell";
import { visitorNav } from "./VisitorDirectory";
import CatalogueModal from "@/components/CatalogueModal";
import { Spinner, Overline } from "@/components/Brand";
import { MapPin, FileText, Sparkles } from "lucide-react";

export default function VisitorSaved() {
  const [tab, setTab] = useState("exhibitors");
  const [favs, setFavs] = useState(null);
  const [cats, setCats] = useState(null);
  const [viewCat, setViewCat] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/visitor/favourites").then(({ data }) => setFavs(data));
    api.get("/visitor/saved-catalogues").then(({ data }) => setCats(data));
  }, []);

  return (
    <Shell nav={visitorNav}>
      <Overline>Your Shortlist</Overline>
      <h1 className="font-display text-3xl gold-text mt-2">Saved</h1>

      <div className="flex gap-2 mt-5">
        <button data-testid="tab-exhibitors" onClick={() => setTab("exhibitors")} className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${tab === "exhibitors" ? "btn-gold" : "glass text-slate-300"}`}>
          Favourites {favs ? `(${favs.length})` : ""}
        </button>
        <button data-testid="tab-catalogues" onClick={() => setTab("catalogues")} className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition ${tab === "catalogues" ? "btn-gold" : "glass text-slate-300"}`}>
          Catalogues {cats ? `(${cats.length})` : ""}
        </button>
      </div>

      {tab === "exhibitors" ? (
        !favs ? <Spinner /> : favs.length === 0 ? (
          <p className="text-slate-400 text-center py-16">No favourites yet.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
            {favs.map((ex) => (
              <div key={ex.id} onClick={() => navigate(`/visitor/exhibitor/${ex.id}`)} className="glass rounded-2xl p-4 flex items-center gap-3 card-lift cursor-pointer" data-testid={`fav-${ex.id}`}>
                <div className="h-14 w-14 rounded-xl bg-cover bg-center shrink-0" style={{ backgroundImage: `url(${ex.logo_url})` }} />
                <div className="min-w-0">
                  <div className="text-slate-100 font-medium truncate">{ex.name}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-400"><MapPin size={11} /> {ex.hall} · {ex.booth}</div>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        !cats ? <Spinner /> : cats.length === 0 ? (
          <p className="text-slate-400 text-center py-16">No saved catalogues yet.</p>
        ) : (
          <div className="space-y-3 mt-5">
            {cats.map((c) => (
              <div key={c.id} className="glass rounded-2xl p-4 flex items-center gap-3" data-testid={`saved-cat-${c.id}`}>
                <div className="h-11 w-11 rounded-xl bg-amber-500/10 flex items-center justify-center shrink-0">
                  {c.type === "ai" ? <Sparkles size={18} className="text-amber-400" /> : <FileText size={18} className="text-amber-400" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-slate-100 font-medium truncate">{c.title}</div>
                  <div className="text-[11px] text-slate-500">{c.exhibitor_name}</div>
                </div>
                {c.type === "ai" && (
                  <button onClick={() => setViewCat(c)} className="text-xs text-amber-300 underline" data-testid={`saved-view-ai-${c.id}`}>View</button>
                )}
                {c.type === "pdf" && c.storage_path && (
                  <a href={`${API}/files/${c.storage_path}`} target="_blank" rel="noreferrer" className="text-xs text-amber-300 underline">Open</a>
                )}
              </div>
            ))}
          </div>
        )
      )}
      {viewCat && <CatalogueModal catalogue={viewCat} visitor onClose={() => setViewCat(null)} />}
    </Shell>
  );
}
